// extracted by mini-css-extract-plugin
export default {"title":"empty_block_title__Ztb8i","container":"empty_block_container__koaVg"};